export function UserMealFormFooter({
  setShowConfirmCancelModal,
  confirmButtonText,
  onSubmit,
  isFormComplete,
}) {
  return (
    <div className="flex-shrink-0 border-t border-gray-200 bg-white px-4 py-4 sm:px-8 flex gap-3">
      <button
        type="button"
        onClick={onSubmit}
        disabled={!isFormComplete}
        className="flex-1 sm:flex-none px-6 py-3 bg-gray-900 text-white rounded-xl font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:bg-gray-800 enabled:active:bg-gray-700"
      >
        {confirmButtonText}
      </button>
      <button
        type="button"
        onClick={() => setShowConfirmCancelModal(true)}
        className="flex-1 sm:flex-none px-6 py-3 border border-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors"
      >
        Cancel
      </button>
    </div>
  );
}
